import React from 'react';

import { FormMeta } from 'common/components/Form/propTypes';
import classNames from 'classnames';

class Checkbox extends React.Component {
  static propTypes = {
    meta: FormMeta.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.input.checked,
    };
  }

  render() {
    const { label, meta, className, ...props } = this.props;
    const { ...input } = props.input;
    const { touched, error, warning } = meta;
    const id = `checkbox-${input.name}`;
    return (
      <div className={classNames(className, 'Field--checkbox')}>
        <input
          type="checkbox"
          id={id}
          checked={this.state.checked}
          {...input}
        />
        <label className="Field__label Field__label--checkbox" htmlFor={id}>
          {label}
        </label>
        {touched &&
          ((error && <div className="Field__error">{error}</div>) ||
            (warning && <div className="Field__warning">{warning}</div>))}
      </div>
    );
  }
}

export default Checkbox;
